// Permissions file

import store from "~/store";
import {isOceanBlueDomain, roles} from "../plugins/utils";
import {config} from "~/plugins/config";

// Use User IDs from production database. This is a temporary solution until we have a better way to handle permissions.
// Only use this for Ocean Blue Casino domain.
const hardcodedUserPermissions = [
  {
    userId: 20521, // Atencion al cliente Velez
    unrestrictedRoutes: [],
    unrestrictedActions: ["admin.withdrawals.download-report", "admin.withdrawals.complete","admin.users.edit.edit-ranking"],
    restrictedRoutes: [],
    restrictedActions: []
  },
  {
    userId: 35485, // Alfonsina Mejia
    unrestrictedRoutes: [],
    unrestrictedActions: ["admin.users.edit.edit-deposit-methods", "admin.users.edit.edit-basic-fields" ],
    restrictedRoutes: [],
    restrictedActions: []
  },
  {
    userId: 26255, // Marielvy Grullon
    unrestrictedRoutes: [],
    unrestrictedActions: ["admin.change-status-tickets-drawing"],
    restrictedRoutes: [],
    restrictedActions: []
  },

  {
    userId: 13927, // Atencion al cliente 100
    unrestrictedRoutes: [],
    unrestrictedActions: ["admin.withdrawals.download-report","admin.withdrawals.complete", "admin.users.edit.edit-ranking"],
    restrictedRoutes: [],
    restrictedActions: []
  },
  {
    userId: 572, // soportealcliente2 Glenny
    unrestrictedRoutes: [
      'admin.user-tracking.index',
      'admin.user-tracking.dashboard',
      'admin.user-tracking.user.panel',
      'admin.user-tracking.group',
      'admin.user-tracking.group.panel',
      'admin.user-tracking.assign-users',
      'admin.user-tracking.configuration',
    ],
    unrestrictedActions: [
      "admin.users.edit.edit-password",
      "admin.users.edit.edit-ranking",
      "admin.users.edit.edit-basic-fields",
      "admin.users.edit.edit-deposit-methods",
    ],
    restrictedRoutes: [],
    restrictedActions: []
  },
  {
    userId: 47585, // soporte Scarlet Luna
    unrestrictedRoutes: [
      'admin.user-tracking.index',
      'admin.user-tracking.dashboard',
      'admin.user-tracking.user.panel',
      'admin.user-tracking.group',
      'admin.user-tracking.group.panel',
      'admin.user-tracking.assign-users',
      'admin.user-tracking.configuration',
    ],
    unrestrictedActions: [
      "admin.users.edit.edit-basic-fields",
      "admin.users.edit.edit-ranking",
    ],
    restrictedRoutes: [],
    restrictedActions: []
  },
  {
    userId: 47059, // Supervisor Eridania Sanchez
    unrestrictedRoutes: [
      'admin.user-tracking.index',
      'admin.user-tracking.dashboard',
      'admin.user-tracking.user.panel',
      'admin.user-tracking.group',
      'admin.user-tracking.group.panel',
      'admin.user-tracking.assign-users',
      'admin.user-tracking.configuration',
    ],
    unrestrictedActions: ["admin.deposits.download-report"],
    restrictedRoutes: [],
    restrictedActions: []
  },
  {
    userId: 18490, // invobc7@gmail.com Leonela
    unrestrictedRoutes: [],
    unrestrictedActions: [],
    restrictedRoutes: [],
    restrictedActions: [
      'admin.withdrawals.complete',
      'admin.withdrawals.update',
      'admin.withdrawals.cancel',
    ]
  },
  {
    userId: 10852, // invobc5@gmail.com Karen
    unrestrictedRoutes: [],
    unrestrictedActions: [],
    restrictedRoutes: [],
    restrictedActions: [
      'admin.withdrawals.complete',
      'admin.withdrawals.update',
      'admin.withdrawals.cancel',
    ]
  },
  {
    userId: 2992, // invobc@gmail.com Karina
    unrestrictedRoutes: [],
    unrestrictedActions: [],
    restrictedRoutes: [],
    restrictedActions: [
      'admin.withdrawals.complete',
      'admin.withdrawals.update',
      'admin.withdrawals.cancel',
    ]
  },
]

export function hasPermissionByRouteName(routeName) {
  const role = store.state?.auth?.user?.role;
  const isPos = config("app.is_pos");
  const userId = store.state?.auth?.user?.id;

  if (isOceanBlueDomain) {
    // Get hardcoded user permissions
    const hardcodedUserPermission = hardcodedUserPermissions.find(hardcodedUserPermission => hardcodedUserPermission.userId === userId);
    if (hardcodedUserPermission) {
      if (hardcodedUserPermission.unrestrictedRoutes.includes(routeName)) return true;
      if (hardcodedUserPermission.restrictedRoutes.includes(routeName)) return false;
    }
  }

  // Get route permission
  const routePermission = permissionsPerRouteName[routeName];

  // Return early if there isn't a permission for this route
  if (!routePermission) return true;

  return isPos
    ? routePermission.posRoles.includes(role)
    : routePermission.roles.includes(role);
}

export function hasPermissionByAction(action) {
  const role = store.state?.auth?.user?.role;
  const isPos = config("app.is_pos");
  const userId = store.state?.auth?.user?.id;

  if (isOceanBlueDomain) {
    // Get hardcoded user permissions
    const hardcodedUserPermission = hardcodedUserPermissions.find(hardcodedUserPermission => hardcodedUserPermission.userId === userId);
    if (hardcodedUserPermission) {
      if (hardcodedUserPermission.unrestrictedActions.includes(action)) return true;
      if (hardcodedUserPermission.restrictedActions.includes(action)) return false;
    }
  }

  // Get action permission
  const actionPermission = permissionsPerAction[action];

  // Return early if there isn't a permission for this route
  if (!actionPermission) return true;

  return isPos
    ? actionPermission.posRoles.includes(role)
    : actionPermission.roles.includes(role);
}

export const permissionsPerRouteName = {
  game: {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },
  // Todo: Remove this route after homev2 is done
  homev2: {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "user.affiliate": {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.dashboard.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.dashboard.users": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.dashboard.affiliates": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.dashboard.games": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.dashboard.accounting": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.my-dashboard.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.my-dashboard.general": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.my-dashboard.global": {
    roles: [roles.ADMIN],
    posRoles: [roles.ADMIN],
  },
  "admin.affiliate.tree": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.affiliate.commissions.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.affiliate.commissions.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.affiliate.commissions.reject": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.affiliate.commissions.approve": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Users
  "admin.users.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.list": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.users-without-referrer": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.users-activity": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.users-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.users.mail": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },

  // Sellers
  "admin.sellers.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sellers.create": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.sellers.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sellers.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sellers.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sellers.mail": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.sellers.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Supervisors
  "admin.supervisors.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.supervisors.create": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.supervisors.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.supervisors.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.supervisors.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.supervisors.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Payment
  "admin.deposits.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposits.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.withdrawals.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.affiliate.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "user.account.deposits.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "user.account.withdrawals.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposit-methods.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawal-methods.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "user.account.transactions": {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN],
  },
  "user.account.deposits.create": {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN],
  },
  "user.account.withdrawals.create": {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN],
  },
  "user.account.deposits.complete": {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.payment-banks.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposits.show": {
    roles: [
      roles.USER,
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposits.transaction": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawals.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawals.transaction": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawal-methods.create": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawal-methods.info": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawal-methods.balance": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawal-methods.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.withdrawal-methods.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposit-methods.create": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposit-methods.info": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposit-methods.balance": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposit-methods.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.deposit-methods.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },

  // Accounts
  "admin.accounts.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.accounts.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.accounts.debit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_ASSISTANT
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.accounts.credit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_ASSISTANT
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.accounts.transactions": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // General Transaction
  "admin.generic-transactions.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.SUPERVISOR,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // General stuff
  "changelog": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR,
      roles.CUSTOMER_SERVICE
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR,
      roles.CUSTOMER_SERVICE
    ]
  },
  "admin.manual-transactions.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.credits-debits.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.games.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.games.show": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.games.details": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.sites.index": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "admin.reports.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.settings.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.support-tickets.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.chat.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.license.index": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "admin.add-ons.index": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "admin.maintenance.index": {
    roles: [roles.ADMIN],
    posRoles: [roles.ADMIN],
  },
  "tutorial.list": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [],
  },
  support: {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  history: {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.user": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.recent": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.wins": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.losses": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.games.show": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.games.details": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  "history.games.verify": {
    roles: [roles.ADMIN],
    posRoles: [],
  },
  leaderboard: {
    roles: [roles.ADMIN],
    posRoles: [],
  },

  // Reports
  "admin.reports.daily-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.reports.weekly-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // External Games
  "egames-american-roulette": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [],
  },

  // Other
  other: {
    roles: [roles.ADMIN, roles.MANAGER, roles.FINANCIAL_SUPERVISOR],
    posRoles: [],
  },

  // Admin Lottery Routes
  "admin.lottery.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.lottery-banks": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.results": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.voucher-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.tickets-in-process": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.won-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.past-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
  },
  "admin.lottery.lottery-banks.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.configuration": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.user-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.sellers": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // User Lottery Routes
  "user.lottery.tickets.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.lottery.panel": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.lottery.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.lottery.tickets.past-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.lottery.tickets.tickets-in-process": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.lottery.tickets.won-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.lottery.create-ticket": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },

  // Admin Sports Bet Routes
  "admin.sports-bet": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.categories": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.events": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.matches": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.bets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.default-questions": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.configuration": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.results": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // User Sports bet routes
  "user.sports-bet.dashboard": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.sports-bet.matches": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },
  "user.sports-bet.bet-history": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.USER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER, roles.USER],
  },

  //Chat
  "admin.chat.rooms.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },
  "admin.chat.rooms.create": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },
  "admin.chat.rooms.edit": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },
  "admin.chat.rooms.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },
  "admin.chat.messages.index": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },
  "admin.chat.messages.delete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER
    ],
    posRoles: [],
  },

  //Add-ons
  "admin.add-ons.install": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [],
  },
  "admin.add-ons.changelog": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [],
  },

  // User Tracking
  "admin.user-tracking.index": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.user-tracking.dashboard": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.user-tracking.user.panel": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.user-tracking.group": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.user-tracking.group.panel": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.user-tracking.assign-users": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING
    ],
    posRoles: [roles.ADMIN],
  },
  "admin.user-tracking.configuration": {
    roles: [
      roles.ADMIN,
      roles.USER_TRACKING
    ],
    posRoles: [roles.ADMIN],
  },
};

export const permissionsPerAction = {
  // Admin Users
  "admin.users.edit.edit-basic-fields": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-password": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
      roles.CUSTOMER_SERVICE
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-ranking": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.account.create-bank-account": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-role": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-other-fields": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-blocked": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-deposit-methods": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-paywall-endpoint": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.users.edit.edit-create-commissions-referrer": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Lottery
  "user.view-lottery-panel": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SELLER,
      roles.FINANCIAL_ASSISTANT]
    ,
    posRoles: [roles.ADMIN, roles.MANAGER, roles.SELLER],
  },
  "admin.lottery.revalidate-drawing": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.CUSTOMER_SERVICE
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.create-lottery": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.add-picks-to-lotteries": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.cancel-drawing": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.change-status-tickets-drawing": {
    roles: [],
    posRoles: [],
  },
  "admin.delete-drawing": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.view-and-copy-results": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.mark-as-canceled": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.mark-as-loser": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.lottery.mark-as-paid-payment-pending-tickets": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Deposits
  "admin.deposits.download-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposits.view-statistics": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposits.view-user-info": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposits.complete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposits.cancel": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.deposits.update": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Withdrawals
  "admin.withdrawals.download-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.withdrawals.view-statistics": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.withdrawals.view-user-info": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.withdrawals.complete": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.withdrawals.cancel": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.withdrawals.update": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.SUPERVISOR,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR,
      roles.FINANCIAL_ASSISTANT,
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Generic Transaction
  "admin.generic-transactions.download-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.generic-transactions.view-statistics": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.FINANCIAL_ASSISTANT,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // Sports Bet
  "admin.sports-bet.import-lines": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },
  "admin.sports-bet.create-match": {
    roles: [
      roles.ADMIN,
      roles.MANAGER
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

  // General
  "admin.users.download-report": {
    roles: [
      roles.ADMIN,
      roles.MANAGER,
      roles.CUSTOMER_SERVICE,
      roles.FINANCIAL_SUPERVISOR
    ],
    posRoles: [roles.ADMIN, roles.MANAGER],
  },

};